module.exports = __webpack_public_path__ + "9325affff63478cad8476320e867c742.svg";